import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
export function WomanThinkingIllustration() {
  return _jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: 160,
    height: 160,
    fill: "none",
    children: [_jsxs("g", {
      clipPath: "url(#a)",
      children: [_jsx("circle", {
        cx: 80.398,
        cy: 80,
        r: 74,
        fill: "#E6EFFF",
        opacity: 0.7
      }), _jsx("mask", {
        id: "b",
        width: 149,
        height: 148,
        x: 6,
        y: 6,
        maskUnits: "userSpaceOnUse",
        style: {
          maskType: 'alpha'
        },
        children: _jsx("circle", {
          cx: 80.398,
          cy: 80,
          r: 74,
          fill: "#E6EFFF"
        })
      }), _jsxs("g", {
        mask: "url(#b)",
        children: [_jsx("path", {
          fill: "#68208D",
          d: "M51.744 76.595c6.471-4.978 7.164-31.764 11.196-36.414l38.472-3.915c8.06 5.23 8.517 19.223 1.743 29.523-6.773 10.3-51.411 10.806-51.411 10.806Z"
        }), _jsx("path", {
          stroke: "#3C1053",
          strokeWidth: 0.909,
          d: "M105.322 60.808c-.683 3.43-4.997 10.635-16.796 12.007"
        }), _jsx("path", {
          fill: "#C0885E",
          d: "M72.34 53.845c-.102-.908.671-1.633 1.534-1.411l18.709 4.796c.97.248 1.395 1.516.81 2.3-2.496 3.35-7.052 10.964-2.823 17.513.724 1.12-18.483 3.7-19.95-.314-.073-.201-.038-.418.03-.612 2.873-8.12 2.156-18.175 1.69-22.272Z"
        }), _jsx("path", {
          fill: "#B56C36",
          fillRule: "evenodd",
          d: "m70.08 75.557.471-7.978 18.777-1.508c-.932 4.013-3.49 10.865-10.925 12.573-4.605 1.058-7.091-.785-8.323-3.087Z",
          clipRule: "evenodd"
        }), _jsx("path", {
          fill: "#C0885E",
          d: "M68.444 40.09c2.612-5.137 7.107-9.08 16.54-6.614 9.237 2.415 11.374 9.199 11.258 12.71-.077 2.35-1.35 7.588-2.184 10.794a130.95 130.95 0 0 0-1.3 5.38 3.66 3.66 0 0 1-2.144 2.612c-5.242 2.232-8.256 3.8-9.54 4.441-2.966 1.482-7.802.437-11.458-2.284-1.113-.829-3.06-4.336-4.34-7.119-.665-1.449-.809-3.058-.56-4.604.62-3.848.678-4.123.83-4.824.217-1.011 1.783-3.562 1.939-4.284a.739.739 0 0 0 .01-.055c.292-2.117-.006-4.273.95-6.152Z"
        }), _jsx("path", {
          stroke: "#8D522A",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 1.248,
          d: "M71.21 68.619c1.878 1.056 6.648 2.624 10.712.45l8.172-3.933"
        }), _jsx("path", {
          fill: "#301601",
          stroke: "#301601",
          strokeWidth: 0.321,
          d: "M82.392 48.194c.456.107.78.6.702 1.118-.077.518-.52.832-.976.726-.456-.107-.78-.6-.703-1.118.077-.518.521-.832.977-.726ZM71.31 45.57c.45.125.75.63.646 1.146-.104.515-.565.808-1.014.682-.448-.125-.748-.63-.644-1.146.103-.515.565-.808 1.013-.682Z"
        }), _jsx("path", {
          stroke: "#301601",
          strokeWidth: 1.122,
          d: "M79.057 48.648c1.017-.622 3.663-1.17 6.112 1.614M67.899 46.01c1.017-.623 3.663-1.171 6.111 1.614"
        }), _jsx("path", {
          stroke: "#301601",
          strokeWidth: 1.283,
          d: "M79.172 44.145c1.88-.455 5.934-.127 8 3.391M75.225 43.468c-1.472-1.412-5.174-3.222-8.415-.985"
        }), _jsx("path", {
          fill: "#B56C36",
          d: "M70.87 54.513c2.054.227 5.869.97 4.697 2.131-1.464 1.451-5.641-.786-4.697-2.131Z"
        }), _jsx("path", {
          stroke: "#8D522A",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 0.962,
          d: "M76.214 48.041c-.987 1.149-3.24 3.621-4.356 4.324-1.394.879-.673 3.287.672 3.5m2.412.084c.503.086 1.576.434 1.848 1.14"
        }), _jsx("path", {
          fill: "#C0885E",
          d: "m91.375 58.146-1.242 6.052c5.622 1.545 7.08-2.234 7.357-3.584.277-1.35.382-4.42-2.454-5.199-2.269-.623-3.386 1.561-3.661 2.731Z"
        }), _jsx("path", {
          stroke: "#8D522A",
          strokeWidth: 0.962,
          d: "M90.132 64.488c.77.195 1.458.293 2.071.315M91.11 62.267c.703-.268 2.378-.837 1.727-2.713-.651-1.876.267-2.607 1.419-2.434.7.105 1.453.558 1.537 1.846"
        }), _jsx("path", {
          stroke: "#8D522A",
          strokeWidth: 0.962,
          d: "M92.838 59.616c.677.03 2.032.093 2.144 1.214.11 1.088-.949 1.295-1.272 1.206"
        }), _jsx("path", {
          fill: "#68208D",
          d: "M77.344 40.757c-7.711-3.911-15.993 8.237-15.994 5.738-.003-12.447 7.984-18.385 14.095-20.284 6.83-2.122 20.94.11 26.253 9.708 4.427 15.843 2.601 23.198-.174 29.374l-9.022-.682s2.689-.105 3.2-.84c4.16-5.989 1.413-7.746.268-8.222-1.89-.784-3.52.089-4.119 2.736L89.91 47.832l2.872-4.774s-7.726 1.61-15.437-2.301Z"
        }), _jsx("path", {
          stroke: "#3C1053",
          strokeWidth: 0.909,
          d: "M92.601 42.74c-1.394.7-6.156 2.312-12.566-.732-5.232-2.485-6.24-2.273-9.769-1.117-2.309.756-4.991 3.483-4.991 3.483s-2.594 21.777-7.702 26.428M91.35 29.827c1.248.212 4.272 1.539 6.386 5.149M96.031 48.242c1.146.919 3.03 3.407 1.4 6.012"
        }), _jsx("path", {
          fill: "#fff",
          d: "m89.136 74.695 15.265 5.458a19.206 19.206 0 0 1 6.499 3.91c2.176-.477 2.651 1.66 2.602 2.885 1.656.128 2.177 2.495 2.23 3.663l-.149.021a19.205 19.205 0 0 1 1.568 8.31l-.758 21.67a26.606 26.606 0 0 1-2.349 10.039l-.111.245a5.775 5.775 0 0 1-2.312 2.584l-1.281.761a17.325 17.325 0 0 1-4.799 1.948l-1.435.345 4.619 17.788H54.578l2.707-13.695-3.782-26.223a29.176 29.176 0 0 1 1.238-13.509l5.411-16.007c3.822-3.398 14.97-10.193 28.984-10.193Z"
        }), _jsx("path", {
          fill: "#E6EFFF",
          d: "m97.097 149.067-40.132-9.188c-.477-3.456 6.976-.224 8.76-1.116 2.229-1.114 8.065-3.981 16.084-3.981h24.013c1.98 5.94 4.322 19.54 4.322 19.54H90.568l6.53-5.255Z"
        }), _jsx("path", {
          fill: "#C0885E",
          d: "m88.659 74.058 4.619 2.277c-1.115 2.708-9.714 8.816-15.448 14.97-10.033-1.592-7.007-4.459-11.467-10.717 5.827-3.586 16.346-4.675 21.226-9.68.413-.058.52.98.639 1.881l.43 1.27Z"
        }), _jsx("path", {
          stroke: "#85B3FF",
          strokeWidth: 1.317,
          d: "M71.459 89.395c.956.638 3.981 1.752 5.892 2.23 0 1.433-2.707 12.263-1.114 19.429 2.073 4.221-.714 17.905-1.115 26.755-.462 10.182 1.274 15.409 1.274 16.403"
        }), _jsx("path", {
          fill: "#C0885E",
          d: "M81.34 85.733s1.58-1.34 1.368-4.312l-10.923-3.81-1.144 11.487 5.126 1.413c1.645-.053 5.574-4.778 5.574-4.778Z"
        }), _jsx("path", {
          fill: "#fff",
          d: "m56.488 89.554 3.983-4.984-1.626 48.02c-.145 4.295-4.255 7.333-8.404 6.214a6.67 6.67 0 0 1-4.799-7.776l6.642-32.498a21.163 21.163 0 0 1 4.204-8.976Z"
        }), _jsx("path", {
          fill: "#B56C36",
          d: "M57.285 117.901h-9.01l-2.07 9.715 5.983 8.918 5.097-18.633Z"
        }), _jsx("path", {
          fill: "#C0885E",
          d: "M64.292 138.594c2.586-4.156 2.615-6.345 2.256-8.013 3.645-1.155 24.538-7.682 33.418-10.765l16.721.319-2.07 10.511-2.548 3.344c-13.377 4.604-31.532 2.867-35.6 3.159l-12.177 1.445Z"
        }), _jsx("path", {
          stroke: "#85B3FF",
          strokeWidth: 1.317,
          d: "M101.399 94.97c.106 4.777 0 16.371-1.274 24.525"
        }), _jsx("path", {
          fill: "#C0885E",
          d: "M65.408 105.273c1.274 8.664.53 17.837 0 21.34-2.707 15.607-7.963 12.47-11.148 12.31-2.548-.127-3.397-4.937-5.096-9.236l10.989-49.576 19.27-12.534 1.433 2.389-4.141 3.026 1.164 11.882-12.63 7.968c-.637-1.125-1.115 3.768.159 12.431Z"
        }), _jsx("path", {
          fill: "#B56C36",
          d: "M61.485 68.327c3.727 1.02 3.537 6.583 2.976 9.237l-4.787 4.778 1.811-14.015Z"
        }), _jsx("path", {
          fill: "#C0885E",
          d: "m61.267 123.587 8.28 6.689c0 6.498-1.645 7.373-2.866 8.17-4.777.318-15.193.764-17.995 0-3.504-.956-2.867-2.437-2.867-3.551 0-1.115-.478-2.071-1.911-3.186-1.147-.891-1.433-3.238-1.433-4.299 2.76.212 8.981.7 11.784.955 2.803.255 4.035-1.274 4.3-2.07-.637-.637-2.389-1.879-4.3-1.752-1.91.127-2.6-1.539-2.707-2.389 5.86-1.146 8.918.478 9.715 1.433Z"
        }), _jsx("path", {
          stroke: "#8D522A",
          strokeWidth: 1.248,
          d: "m76.873 76.598-4.459 2.707M77.192 80.419l-4.46 2.707M61.586 68.327c1.38.478 3.918 2.93 3.026 8.918M62.223 78.996l17.358-11.26 1.434 2.332-9.556 6.37M48.367 138.764h13.537c5.096 0 15.447-2.389 21.977-1.434 3.456.506 9.188.476 14.81-.23 4.999-.629 9.911-1.793 13.059-3.592 5.351-3.057 5.15-18.314 5.415-29.621.159-3.629.096-11.524-1.433-14.072-.053-1.114-.574-3.28-2.23-3.025.053-2.283-1.242-5.479-6.848 0"
        }), _jsx("path", {
          stroke: "#85B3FF",
          strokeWidth: 1.317,
          d: "M106.654 86.79c5.606-5.479 6.901-2.283 6.848 0 1.656-.255 2.177 1.91 2.23 3.025 1.529 2.548 1.592 10.443 1.433 14.072-.109 4.643-.302 11.466-.671 16.323"
        }), _jsx("path", {
          stroke: "#8D522A",
          strokeWidth: 0.962,
          d: "M48.367 138.765h13.537c5.096 0 15.447-2.389 21.977-1.434 3.456.506 9.188.476 14.81-.23"
        }), _jsx("path", {
          stroke: "#8D522A",
          strokeWidth: 1.248,
          d: "M43.908 130.974h8.281M45.818 134.794H54.1M42.475 127.458h14.651c.796-.637 1.752-2.134-.796-3.026-3.185-1.115-5.256.159-5.256-3.344h8.76l9.555 8.918"
        }), _jsx("path", {
          stroke: "#8D522A",
          strokeWidth: 1.248,
          d: "m76.715 74.219.955 10.979-12.74 7.325c-.372 1.274-.892 6.253 0 8.928 1.115 3.345 3.026 15.757 0 24.675"
        }), _jsx("path", {
          stroke: "#85B3FF",
          strokeWidth: 0.962,
          d: "M100.297 118.818c-1.95.54-7.542 1.428-14.308.663"
        }), _jsx("ellipse", {
          cx: 0.804,
          cy: 0.787,
          fill: "#84B3FF",
          rx: 0.804,
          ry: 0.787,
          transform: "matrix(.99736 -.07211 .05296 .99857 73.72 92.87)"
        }), _jsx("ellipse", {
          cx: 0.804,
          cy: 0.787,
          fill: "#84B3FF",
          rx: 0.804,
          ry: 0.787,
          transform: "matrix(.99736 -.07211 .05296 .99857 74.008 115.28)"
        }), _jsx("ellipse", {
          cx: 0.804,
          cy: 0.787,
          fill: "#84B3FF",
          rx: 0.804,
          ry: 0.787,
          transform: "matrix(.99736 -.07211 .05296 .99857 73.05 126.109)"
        }), _jsx("ellipse", {
          cx: 0.804,
          cy: 0.787,
          fill: "#84B3FF",
          rx: 0.804,
          ry: 0.787,
          transform: "matrix(.99736 -.07211 .05296 .99857 72.096 139.485)"
        }), _jsx("ellipse", {
          cx: 0.804,
          cy: 0.787,
          fill: "#84B3FF",
          rx: 0.804,
          ry: 0.787,
          transform: "matrix(.99736 -.07211 .05296 .99857 73.05 150.956)"
        }), _jsx("ellipse", {
          cx: 0.804,
          cy: 0.787,
          fill: "#84B3FF",
          rx: 0.804,
          ry: 0.787,
          transform: "matrix(.99736 -.07211 .05296 .99857 72.602 103.914)"
        }), _jsx("path", {
          stroke: "#8D522A",
          strokeLinecap: "round",
          strokeWidth: 0.957,
          d: "M72.38 63.007c.835-.5 1.803-1.602 6.007-1.001M75.385 63.756c.292-.25.876-.25 1.877-.125"
        })]
      }), _jsx("path", {
        stroke: "#84B3FF",
        strokeLinecap: "round",
        strokeWidth: 1.6,
        d: "m8.284 12.704-3.29-3.962M3.973 17.058.714 16.23M13.384 9.503l-.226-3.1"
      }), _jsx("path", {
        fill: "#579FFF",
        fillRule: "evenodd",
        d: "M18.493 15.088c-7.81 0-14.141 6.331-14.141 14.141s6.33 14.142 14.141 14.142h13.25l4.488 4.682c1.039 1.084 2.868.35 2.868-1.152V43.32c7.243-.615 12.93-6.689 12.93-14.09 0-7.81-6.332-14.142-14.142-14.142H18.493Z",
        clipRule: "evenodd"
      }), _jsx("path", {
        fill: "#fff",
        d: "M25.842 31.457c0-.524.085-.983.256-1.376.183-.406.4-.746.648-1.021a19.89 19.89 0 0 1 1.022-.983c.524-.458.91-.851 1.16-1.179.248-.34.372-.746.372-1.218 0-.642-.248-1.152-.746-1.532-.498-.393-1.186-.59-2.063-.59-1.533 0-2.705.518-3.517 1.552L21.54 24.09a5.404 5.404 0 0 1 2.102-1.631c.864-.38 1.86-.57 2.986-.57 1.428 0 2.561.315 3.4.943.838.616 1.257 1.467 1.257 2.555 0 .537-.092 1.015-.275 1.434-.17.406-.38.746-.629 1.021a14.68 14.68 0 0 1-1.002.983c-.537.484-.937.91-1.199 1.277-.248.367-.373.819-.373 1.356h-1.965Zm1.002 4.46c-.366 0-.674-.118-.923-.354a1.266 1.266 0 0 1-.354-.904 1.2 1.2 0 0 1 .354-.884c.249-.249.557-.373.923-.373.367 0 .668.124.904.373a1.2 1.2 0 0 1 .354.884c0 .354-.125.655-.373.904a1.2 1.2 0 0 1-.885.354Z"
      })]
    }), _jsx("defs", {
      children: _jsx("clipPath", {
        id: "a",
        children: _jsx("path", {
          fill: "#fff",
          d: "M0 0h160v160H0z"
        })
      })
    })]
  });
}